export default __webpack_public_path__ + "static/media/Monger-HUD-05.33fed808.jpg";